import groq from 'groq';
import { AssetFragment } from './image';
import { ComponentType } from '$lib/sanity/types';

export const CarouselFragment = groq`
  images[] {..., ${AssetFragment}},
  "imageRefs": images
`;

export const GetCarouselComponentQuery = groq`
*[_type == "${ComponentType.Carousel}" && _id == $id]{
  ...,
  ${CarouselFragment}
}[0]`;
